import { SyntheticEvent, useRef, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useLogout, useResetStore, useTranslate } from 'react-admin'
// @mui
import { alpha } from '@mui/material/styles'
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton } from '@mui/material'
// components
import { MenuPopover } from '../popover'
import RolesInfoSection from './RolesInfoSection'
import { imageUrlConcat } from '../../utils/url-concat'
import { AccountPopoverProps } from './type'

// ----------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function AccountPopover({ identity }: AccountPopoverProps): JSX.Element {
  const translate = useTranslate()
  const MENU_OPTIONS = [
    {
      label: translate('component.accountPopover.home'),
      icon: 'eva:home-fill',
      linkTo: '/',
    },
    {
      label: translate('ra.auth.user_menu'),
      icon: 'eva:person-fill',
      linkTo: '/profile/',
    },
  ]

  const logout = useLogout()
  const reset = useResetStore()
  const anchorRef = useRef(null)

  const [open, setOpen] = useState(null)

  const handleOpen = (event: SyntheticEvent): void => {
    setOpen(event.currentTarget)
  }

  const handleClose = (): void => {
    setOpen(null)
  }

  const handleLogout = (): void => {
    setOpen(null)
    reset()
    logout()
  }
  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={imageUrlConcat(identity?.avatar)} alt='avatar' />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant='subtitle2' noWrap>
            {`Admin: ${identity?.user_id}` || ''}
          </Typography>
          <Typography variant='subtitle2' noWrap>
            {`${identity?.firstname_th} ${identity?.lastname_th}` || 'Unknown'}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }} noWrap>
            {identity?.email || ''}
          </Typography>
        </Box>
        <RolesInfoSection roles={identity ? [identity?.role] : []} />
        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              to={option.linkTo}
              component={RouterLink}
              onClick={handleClose}
            >
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {translate('ra.auth.logout')}
        </MenuItem>
      </MenuPopover>
    </>
  )
}
